import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC3-C1g8U854BJCN4sRlPaFX1Us0bjNKQ4",
  authDomain: "wizard-online-d2465.firebaseapp.com",
  projectId: "wizard-online-d2465",
  storageBucket: "wizard-online-d2465.firebasestorage.app",
  messagingSenderId: "59595620029",
  appId: "1:59595620029:web:cd2864cf2fb0eab87b81d4",
  measurementId: "G-WNKY4GCS8V",
};

const app = initializeApp(firebaseConfig);
export default app;
